@use "../../../../styles/text";

:host {
  color: var(--color-text-base);
  margin-left: var(--spacing-xxs);
  font-family: var(--text-body-font-xs);
  font-weight: var(--text-body-weight-xs);
  font-size: var(--text-body-pixels-xs);
  letter-spacing: var(--text-body-letter-spacing-xs);
  vertical-align: bottom;
}
